var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"thumbnails"},[_c('div',{staticClass:"thumbnails-audience",class:{ visible: _vm.visible }},[_c('img',{attrs:{"src":require("../../../assets/images/sports_bg.png"),"alt":""}})]),_c('div',{staticClass:"thumbnails-radial-gradient",class:{ visible: _vm.visible }})])
}
var staticRenderFns = []

export { render, staticRenderFns }